import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { Affiliate, AffiliateInput } from '@/models/affiliate';

export const createAffiliate = async (data: AffiliateInput): Promise<Affiliate> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateAffiliate($data: AffiliateInputType!) {
        createAffiliate(data: $data) {
          id
          name
          codeName
          extension
          promoCode
          phoneNumber
          gogoNumber
          email
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          currency
          timeZone
          description
          isDisabled
          logoUrl
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createAffiliate!;
};
